import axios from "axios";
import {ShareEmailRequest} from "../definitions/types";
import tokenService from "../utils/jwtTokenHandler";

const mobileHeaderElement = document.getElementById('mobile-header-cart');
const mobileCartElement = document.getElementById('shopping-cart');
const cartElement = document.getElementById('nav-cart');

const getBaseUrl = () => {
    switch (window.location.hostname) {
        case 'localhost':
            return window.location.port === '44378' ? '' : 'https://hs1.test.d2go.net';
        default:
            return '';
    }
}

export const BASE_URL = getBaseUrl();

const DEFAULT_HEADERS = {
    "Content-Type": "application/json"
};

const SHARE_EMAIL_REQUEST_CONFIG = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
};

export const instance = axios.create({
    headers: DEFAULT_HEADERS
});

const shareEmailAsync = async (request: ShareEmailRequest) => {
    const formData = new FormData();

    formData.append('g-recaptcha-response', request.token);
    formData.append('ProductID', request.productId.toString());
    formData.append('From', request.from);
    formData.append('ToEmailAddress', request.recipient);
    formData.append('Note', request.note ?? '');
    formData.append('Type', '1');

    return await instance.post(`${BASE_URL}/product/shareproduct`, formData, SHARE_EMAIL_REQUEST_CONFIG);
}

const getJsonWebTokenAsync: () => Promise<string> = async () => {
    const url = `${BASE_URL}/AJAX/identity/token`;
    const {data: jwt, status} = await axios.get<string>(url);
    if (status !== 200) throw new Error(`Unable to get JWT from ${url}`);
    tokenService.set(jwt);
    return jwt;
}

const createQuestionAsync = async (question: string, variantId: number) => {
    return await instance.post(`${BASE_URL}/qa/ask`, JSON.stringify({
        Question: question,
        ID: variantId
    }));
}

const cartBasicInfoAsync = async () => {
    // Break out if the cart element is not found
    if (!mobileCartElement) return;

    instance.get<string>(`${BASE_URL}/ajax/shoppingcart/cartbasic`)
        .then(({status, data}) => status === 200 && (mobileCartElement.innerHTML = data))
        .catch();
}

const cartDropDownAsync = async () => {
    // Break out if the cart element is not found
    if (!cartElement) return;

    instance.get<string>(`${BASE_URL}/ajax/shoppingcart/cartdropdown`)
        .then(({status, data}) => status === 200 && (cartElement.innerHTML = data))
        .catch();
}

export const webService = {
    cart: {
        reload: mobileHeaderElement ? cartBasicInfoAsync : cartDropDownAsync
    },
    identity: {
        token: getJsonWebTokenAsync
    },
    product: {
        share: shareEmailAsync
    },
    qa: {
        ask: createQuestionAsync
    }
}